package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.WhiteboardAction
import fr.manyverse.app.domain.repository.WhiteboardRepository
import kotlinx.coroutines.flow.Flow

/**
 * Use case for observing whiteboard actions in real-time.
 * Returns a flow of actions as they are broadcast by the GM.
 */
class ObserveWhiteboardActionsUseCase(
    private val whiteboardRepository: WhiteboardRepository
) {
    /**
     * Observes whiteboard actions in real-time.
     *
     * @param tableId The game table ID
     * @param whiteboardId The whiteboard ID to observe
     * @return Flow emitting whiteboard actions as they occur
     */
    operator fun invoke(
        tableId: String,
        whiteboardId: String
    ): Flow<WhiteboardAction> {
        return whiteboardRepository.observeWhiteboardActions(
            tableId = tableId,
            whiteboardId = whiteboardId
        )
    }
}
